import { FC, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { scheduleOrder } from 'constants/schedule';

import { showModal } from 'actions/modal';
import { Program } from 'reducers/programs/types';
import Sidebar from './components/Sidebar';
import CalendarCard from './components/CalendarCard';
import CalendarRow from './components/CalendarRow';

import getProgramsSchedule from './utils/getProgramsSchedule';
import { Container, RowsWrapper } from './styles';
import { ProgramData } from './types';
import getScheduleByProgramId from './utils/getScheduleByProgramId';

interface Props {
  className?: string;
}

const SessionsCalendar: FC<Props> = ({ className }) => {
  const programs: Program[] = useSelector((state: any) => state.programs?.all);
  const schedule = getProgramsSchedule(programs);
  const dispatch = useDispatch();

  const handleAddSession = useCallback(
    (rowKey: string) => {
      const index = scheduleOrder.indexOf(rowKey);
      const currentProgram = schedule[index].map(({ id, name, picture }: ProgramData) => ({
        id,
        name,
        picture,
        schedule: programs.find((item) => item.id === id)?.schedule,
      }));
      const availableProgram = programs
        .filter((item) => !currentProgram.find((program) => program.id === item.id))
        .map((item) => ({
          id: item.id,
          name: item.name,
          picture: item.picture,
          schedule: item.schedule,
        }));

      dispatch(
        // @ts-ignore
        showModal('CHANGE_PROGRAM_SCHEDULE', { rowKey, currentProgram, availableProgram }),
      );
    },
    [programs, schedule, dispatch],
  );

  return (
    <Container className={className}>
      <Sidebar />
      <RowsWrapper>
        {schedule.map((day, index) => (
          <CalendarRow key={`${day}${index}`}>
            {day.map((program) => (
              <CalendarCard
                day={scheduleOrder[index]}
                key={program.id}
                program={program}
                schedule={getScheduleByProgramId(program.id, programs)}
              />
            ))}
            <CalendarCard onClick={() => handleAddSession(scheduleOrder[index])} />
          </CalendarRow>
        ))}
      </RowsWrapper>
    </Container>
  );
};

export default SessionsCalendar;
